<div #dropdown='ngbDropdown' [autoClose]="false" ngbDropdown>
  <a ngbDropdownToggle style="display:none"></a>
  <div ngbDropdownMenu class="dropdown-menu-wrapper">
    @for (option of state.dropdownData; track option; let index = $index) {
      <div ngbDropdownItem
        class="dropdown-item"
        [attr.data-cy]="dropdownItemDataCy(option.name, 'item')">
        <div class="dropdown-item-wrapper">
          <span class="dropdown-item-text"
          [attr.data-cy]="dropdownItemDataCy(option.name, 'text')">{{ option.code }} - {{ option.name }}</span>
          <button class="dropdown-item-button"
            [attr.data-cy]="dropdownItemDataCy(index.toString(), 'button')"
            (click)="selectDropdownItem(option)"
            [disabled]="option.selected">
            <span class="iwp-icon-gen_add"></span>
            <span>Add {{multiSelectDropdownLabel}}</span></button>
          </div>
        </div>
      }
    </div>
  </div>

  @if (spinnerObservable | async) {
    <div class="spinner-container">
      <app-loading-spinner class="button-spinner"></app-loading-spinner>
    </div>
  }
